import { styled } from 'styled-components'
import { useBoolean } from 'usehooks-ts'

import type { OrchestratedAuctionListingDetails } from '@b-stock/fe-core/bstock-next/queries'
import { Breakpoints } from '@b-stock/fe-core/design-system'

import { AuctionStatisticModal } from './AuctionStatisticModal'
import { BidCount } from './BidCount'
import { TimeLeft } from './TimeLeft'
import { ViewCount } from './ViewCount'

const Body = styled.div`
  display: flex;
  gap: 1rem;
  margin-bottom: 1rem;
  padding: 0 2rem;

  @media ${Breakpoints.max.medium} {
    padding: 0 1rem;
  }
`

export const StatsBar = ({
  displayAsBuyNow,
  listing,
  isPopcorn,
  isUnscheduled,
}: {
  displayAsBuyNow?: boolean
  listing: OrchestratedAuctionListingDetails
  isPopcorn?: boolean
  isUnscheduled?: boolean
}) => {
  const { auction } = listing
  const { viewCount } = listing.saleMetrics ?? {}

  const {
    setFalse: closeModal,
    setTrue: openStatisticModal,
    value: showModal,
  } = useBoolean(false)

  return (
    <Body>
      <TimeLeft
        auction={auction}
        displayAsBuyNow={displayAsBuyNow}
        isPopcorn={isPopcorn}
        isUnscheduled={isUnscheduled}
      />

      <ViewCount viewCount={viewCount} />

      <BidCount
        displayAsBuyNow={displayAsBuyNow}
        openStatisticModal={openStatisticModal}
      />

      {showModal && (
        <AuctionStatisticModal
          closeModal={closeModal}
          currency="USD"
          listing={listing}
        />
      )}
    </Body>
  )
}
